import clsx from 'clsx';
import styles from './LoadingSpinner.module.scss';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Accessible label for screen readers */
  label?: string;
}

export function LoadingSpinner({ size = 'md', className, label = 'Loading' }: LoadingSpinnerProps) {
  return (
    <div className={clsx(styles.wrapper, className)} role="status" aria-label={label}>
      <div className={clsx(styles.spinner, styles[size])} />
      <span className="sr-only">{label}</span>
    </div>
  );
}
